import React, { FC, useRef } from 'react';
import { Extras } from '@common/components/Extras';
import { SpaPackageExtrasFormProps } from './SpaPackageExtras.types';
import { adaptExtras } from './utils';

const SpaPackageExtras: FC<SpaPackageExtrasFormProps> = ({
  extras,
  selectedGuests,
  selectedExtras,
}) => {
  const selectedGuestRef = useRef(selectedGuests);
  const adaptedExtras = adaptExtras(extras);

  return (
    <Extras
      extras={adaptedExtras}
      selectedExtras={selectedExtras}
      selectedGuests={selectedGuestRef.current}
      showPrice
    />
  );
};

export default SpaPackageExtras;
